<!--
  What a pending write is doing ("Resolving…"), with a small spinner: shown
  on the item the write changes until the server confirms it (see
  state/pending.svelte.ts). The item itself carries `aria-busy` and the
  `is-pending` class (its content dimmed, the tag not).
-->
<script lang="ts">
  interface Props {
    /** The write's label ("Saving reply"). */
    label: string;
  }
  let { label }: Props = $props();
</script>

<span class="pending-tag"><span class="spinner" aria-hidden="true"></span>{label}…</span>
